import React from "react";
import Marquee from "react-fast-marquee";

const ITEMS = [
  "🔥 Personalización en solo 15 minutos",
  "🚚 Envíos a todo Chile",
  "🎁 Regalo sorpresa en compras sobre $20.000",
  "📱 Compatible con iPhone, Samsung, Xiaomi y más",
  "✨ Diseños únicos hechos para ti",
];

export default function PromoStrip() {
  return (
    <div className="marquee-strip py-3" data-testid="promo-strip">
      <Marquee speed={50} gradient={false} pauseOnHover>
        {ITEMS.concat(ITEMS).map((t, i) => (
          <span key={i} className="mx-10">{t}</span>
        ))}
      </Marquee>
    </div>
  );
}
